import { IconProps } from './Icon.types';

export const Left = ({
  size = 24,
  fill = '#000',
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.75 5.75L8.25 12.25L14.75 18.75"
      stroke={fill}
      strokeLinejoin="round"
    />
  </svg>
);
